import $                   from 'jquery';
import React               from 'react';
import ReactDOM            from 'react-dom';
import Reflux              from 'reflux';
import ChoiceActionFactory from './choices/choice-actions-factory';

export default class TextArea extends React.Component {
  constructor(props) {
    super(props);
    if(props.question.responseText==null){
      props.question.responseText = '';
    }
    this.state = props.question;
  }
    componentDidMount() {
        this.ChoiceActions = ChoiceActionFactory.get(this.props.question.questionId);
    }
    componentWillUpdate(nextProps,nextState){
        nextState.responseText = nextProps.question.responseText;
    }
    componentDidUpdate(prevProps, prevState){
        this.ChoiceActions = ChoiceActionFactory.get(this.props.question.questionId);

    }

    render() {
        let className = "choice-item input-field-choice";
        let inputId = `input-field-${this.props.question.questionId}`;
        let inputProps = {
            type: "text",
            name: inputId,
            value: this.props.question.responseText,
            id: inputId,
            onChange: (e) => {
                e.preventDefault();
                let el = e.target;
                let value = el.value;
                this.props.question.responseText = value;
                this.setState({
                    responseText: value
                });
                this.ChoiceActions.change(null,true);
            }
        }

        return(
            <ul className="choices-container">
                <li className={className}>
                    <textarea {...inputProps}   />
                </li>
            </ul>
        )
    }
}
TextArea.propTypes={
    question: React.PropTypes.object.isRequired
}
TextArea.defaultProps={
}



// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/textarea.jsx